// src/layouts/DashboardLayout.jsx

import SidebarAdmin from "../admin/SidebarAdmin";
import FloatingNav from "../components/FloatingNav";
import FooterNav from "../components/FooterNav";
import MobileNavbar from "../components/MobileNavbar";
import Sidebar from "../components/Sidebar";

import { useState } from "react";
import { Outlet } from "react-router-dom";  // ✅ Import Outlet

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen">
      <SidebarAdmin isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 p-4 pt-16 pb-20 md:pt-4 md:pb-4 h-screen overflow-y-auto">
        {/* ✅ Nested routes will render here */}
        <Outlet />

        <FooterNav /> 
        <FloatingNav />
      </div>
    </div>
  );
};

export default AdminLayout;
